import * as userRequest from "@/utils/userRequest";
import { PartialBonuses } from "./type";

export default async function getLogPartialBonusesService(
    onSuccess?: (data?: PartialBonuses) => PartialBonuses,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get(`/affiliates/get-log-partial-bonuses`);
        if (res) {
            onSuccess && onSuccess(res.data);
            return res.data;
        }

        throw Error("Something went wrong");
    } catch (err) {
        console.error("🚀 ~ getLogPartialBonusesService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
